import { FC, ReactText, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { round } from "@jurijtokarski/calc";

import { RouteKey, RoutePath } from "../configs/routes";
import { Layout } from "../components/Layout";
import { useStorage } from "../utils/useStorage";
import { Measure, ML_IN_OZ } from "../utils/context";
import { GoalConfig } from "../components/GoalConfig";

export const SetGoal: FC = () => {
  const { configGoal, configMeasure, setDailyGoalAndMeasure } = useStorage();

  const [touched, setTouched] = useState(false);
  const [visible, setVisible] = useState(false);
  const [goal, setGoal] = useState(configGoal);
  const [measure, setMeasure] = useState(configMeasure);

  const history = useHistory();

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (!visible) {
      return;

    }
    window.scrollTo(0, 0);
  }, [visible]);

  useEffect(() => {
    if (!touched) {
      return;
    }

    const newGoal = measure === Measure.OZ ? goal / ML_IN_OZ : goal * ML_IN_OZ;

    setGoal(round(newGoal, 0));
  }, [measure]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoalChange = (value: number) => {
    if (!touched) {
      setTouched(true);
    }

    setGoal(value);
  }

  const handleMeasureChange = (value: ReactText) => {
    if (!touched) {
      setTouched(true);
    }

    setMeasure(value as Measure);
  }

  const handleSave = () => {
    setDailyGoalAndMeasure && setDailyGoalAndMeasure(goal, measure);
    history.push(`${RoutePath[RouteKey.INDEX]}`);
  }

  return (
    <Layout route={RouteKey.SET_GOAL}>
      <GoalConfig
        goal={goal}
        onGoalChange={handleGoalChange}
        measure={measure}
        onMeasureChange={handleMeasureChange}
        onSave={handleSave}
      />
    </Layout>
  )
};